import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');


const RenderPmtvouchers = () => {


const resturl=sessionStorage.getItem("REST_URL");

const navigate = useNavigate();
const location = useLocation();

window.addEventListener("keypress", function (event) {
 // detect event key
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [tblbrokergrades, setTblbrokergrades] = useState([]);
const [finyears, setFinyears] = useState([]);

const [crit, setCrit] = useState({
YRMM1: ''
, YRMM2: ''
, DEC_COD: ''
});



useEffect(() => {

	if (sessionStorage.getItem("AW_USERNAME")==null){
	navigate("../logout");
	return;
	}
	getfinyears();

},[]);


useEffect(() => {

	if (finyears.length>0){
		gettblgrades(null);
		}

},[JSON.stringify(finyears)]);


function rptremqty(){

const params={
	DEC_COD:"D5018"
	, DATE1:"2018-10-13"
	, DATE2:"2024-10-13"
};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarsad/rptremqty',requestOptions)
      .then(res => res.json())
      .then(res => afterrptremqty(res))
      .catch(err => console.log(err));
	  
return false;
}//end function

function afterrptremqty(res){
	console.log("afterrptremqty");
}


function getfinyears(){

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };

  fetch(resturl+'rarsad/getfinyears',requestOptions)
      .then(res => res.json())
      .then(res => aftergetfinyears(res))
      .catch(err => console.log(err));
	  
return false;
}//end function


function aftergetfinyears(res){
if (res.length==undefined){

	return;
	}
	
let htmoptions=[];
var rownum=1;

res.map((col, index) => {
	const key='finyrs'+index;
			
	htmoptions.push(<option value={col['FINYR']} >{col['YEARNAME']}</option>
	);
	rownum++;
	}//end for
	);

	setFinyears(htmoptions);	

}//end function

function gettblgrades(e){

let params={
	YRMM1: crit.YRMM1
	, YRMM2: crit.YRMM2
	, DEC_COD: crit.DEC_COD
	}

if (e!=null)
	params={
	YRMM1: e.target.value.substring(0,7)
	, YRMM2: e.target.value.substring(11,18)
	, DEC_COD: crit.DEC_COD
	}

console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

	setTblbrokergrades([]);

  fetch(resturl+'rarsad/getbrokergrades',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblgrades(res))
      .catch(err => console.log(err));
	  
return false;
}//end function


function aftergettblgrades(res){
if (res.length==undefined){

	return;
	}
	
let htmrows=[];
var rownum=1;
//<img src='images/pdficon_small.gif' border=0 title='click to download voucher' />
res.map((col, index) => {
	const key='rokergrades'+index;
	const celllink='sadlinkid'+index;
		
	htmrows.push(<tr key={key} >
		<td align="right" >{rownum}</td>
		<td align="center" >{col['ACC_COD']}</td>
		<td align="right" >{col['ACC_AMT']}</td>
		<td align="center" >{col['DEC_COD']}</td>
		<td align="left" >{col['DEC_NAM']}</td>
		<td align="right" >{col['MM04']}</td>
		<td align="right" >{col['MM05']}</td>
		<td align="right" >{col['MM06']}</td>
		<td align="right" >{col['MM07']}</td>
		<td align="right" >{col['MM08']}</td>
		<td align="right" >{col['MM09']}</td>
		<td align="right" >{col['MM10']}</td>
		<td align="right" >{col['MM11']}</td>
		<td align="right" >{col['MM12']}</td>
		<td align="right" >{col['MM01']}</td>
		<td align="right" >{col['MM02']}</td>
		<td align="right" >{col['MM03']}</td>
		</tr>
	);
	rownum++;
	}//end for
	);

	setTblbrokergrades(htmrows);	

}//end function







  return (
    <>
<div align="center" style={{color:"brown"}} >Financial Year Filter:&nbsp;&nbsp;
<select onChange={(e)=>{gettblgrades(e);}} >
{finyears}
</select>

</div>
<div align="center"><h3 style={{marginTop:"6px",marginBottom:"6px"}}  >Account Holders Grades Monthly</h3></div>
<div align="center" style={{color:"navy"}} >Grade is the percentage of Asycuda Declarations that did not require correction when checked at Customs EPU</div>
 <table className="customers" style={{width:"75%", marginBottom:"36px" }}  >
 <thead>
 <tr>
 <th>#</th>
 <th>Account #</th>
 <th>Account Limit</th>
 <th>Dec Cod</th>
 <th>Account Holder Name</th>
 <th>Apr</th>
 <th>May</th>
 <th>Jun</th>
 <th>Jul</th>
 <th>Aug</th>
 <th>Sep</th>
 <th>Oct</th>
 <th>Nov</th>
 <th>Dec</th>
 <th>Jan</th>
 <th>Feb</th>
 <th>Mar</th>
 </tr>
 </thead>
 <tbody>
 {tblbrokergrades}
 </tbody>
 </table>


    </>
  );
};

export default RenderPmtvouchers;